/**
 * ListenerManager - Event Listener Management and Cleanup Utility
 * 
 * Manages DOM event listeners and ensures proper cleanup to prevent memory leaks.
 * Tracks all attached listeners and automatically removes them on page unload.
 */
class ListenerManager {
	constructor() {
		this.listenerList = [];
		this.onUnloadActions = [];
		this.unloadListenerAdded = false;
	}

	safeObserve(el, evStr, func) {
		this.listenerList.push({ el, evStr, func });
		el.addEventListener(evStr, func);
		
		// Automatically set up unload listener if not already done
		if (!this.unloadListenerAdded) {
			window.addEventListener('unload', this.onUnload.bind(this));
			this.unloadListenerAdded = true;
		}
	}

	stopObserve(el, evStr) {
		this.listenerList.forEach((it) => {
			if (it.el == el && it.evStr == evStr) {
				it.el.removeEventListener(it.evStr, it.func);
				it.el = null;
				it.func = null;
				it = null;
			}
		});

		this.listenerList = this.listenerList.filter((item) => item != null);
	}

	stopObserveAllListeners(el) {
		this.listenerList.forEach((it) => {
			if (it.el == el) {
				it.el.removeEventListener(it.evStr, it.func);
				it.el = null;
				it.func = null;
				it = null;
			}
		});

		this.listenerList = this.listenerList.filter((item) => item != null);
	}

	onUnload() {
		this.listenerList.forEach((listenerItem) => {
			if (listenerItem !== null && listenerItem.el !== null) {
				listenerItem.el.removeEventListener(listenerItem.evStr, listenerItem.func);
				delete(listenerItem.el);
				delete(listenerItem.func);
				listenerItem.el = null;
				listenerItem.func = null;
			}
		});

		this.listenerList = [];
		this.onUnloadActions.forEach((action) => {
			action();
			action = null;
		});

		this.onUnloadActions = [];
	}

	registerUnloadAction(func) {
		this.onUnloadActions.push(func);
	}
} 
